import toastMixin from "./mixins/toastMixin";
import $ from "jquery"; 

export function checkCatch(error) {

     if (error.response) {

          // Sesión Expirada
          if (error.response.status == 401 || error.response.status == 419) {

               localStorage.removeItem("token"); // Limpiar el token
               localStorage.removeItem("refresh_token");
               localStorage.removeItem("user"); // Limpiar el user
               localStorage.removeItem("extra_data"); // Limpiar el user
               window.location.href = "/login";

          // Sin acceso a funcionalidad
          } else if (error.response.status == 403) {

               toastMixin.methods.showNotification({

                    description: "No tienes acceso a esta funcionalidad",
                    title: "Atención!",
                    type: "danger",
               });
               
          // Validaciones
          } else if (error.response.status == 422) {

               let data = String();

               if (error.response.data.errors) {

                    $.each(error.response.data.errors, (key, value) => {

                         data += `<li>${value}</li>`;
                    });

               } else if (error.response.data.message) {

                    data += `<li>${error.response.data.message}</li>`;
               }

               toastMixin.methods.showNotification({

                    description: data,
                    title: "Atención!",
                    type: "danger",
                    timeout: 6,
               });
               
          } else if (error.response.status == 429) {
               toastMixin.methods.showNotification({

                    description: 'Ha realizado muchas peticiones en corto tiempo, por favor vuelva a intentar en unos minutos',
                    title: "Atención!",
                    type: "warning",
                    timeout: 6,
               });
               
          } else if (error.response.status == 500) {

               toastMixin.methods.showNotification({

                    description:
                         "Ocurrió un error ejecutando la operación solicitada.",
                    title: "Atención!",
                    type: "danger",
               });
          } else if(error.response.status == 400 && error.response.data.error){
               
               toastMixin.methods.showNotification({

                    description: error.response.data.error,
                    title: "Atención!",
                    type: "danger",
               });
          }
          else {

               console.log("Error -> ", error.message);
          }
     } else {

          console.log("Error -> ", error.message);
     }
}

export function roundNumber(value, decimals = 2) {
     
  return Number(value).toFixed(decimals);
}